import Cookies from "js-cookie";
import stringOrNullToBoolean from "../stringOrNullToBoolean/stringOrNullToBoolean";

const checkIsLoggedIn = async () => {
  return stringOrNullToBoolean(Cookies.get("isLoggedIn"));
};

export default checkIsLoggedIn;
